'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSnapchatSquare = function FaSnapchatSquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 25.6q0-0.5-0.5-0.6-1.5-0.3-2.7-1.3t-1.7-2.4q-0.2-0.3-0.2-0.6 0-0.3 0.4-0.5t1-0.4 0.9-0.5 0.5-0.8q0-0.4-0.4-0.7t-0.9-0.3q-0.2 0-0.7 0.2t-0.7 0.2q-0.1 0-0.3-0.1 0.1-1.4 0.1-2.5 0-1.8-0.3-2.6-0.8-1.7-2.3-2.7t-3.4-1q-4.5 0-6.2 3.7-0.4 0.9-0.4 2.6 0 0.8 0.2 2.5-0.3 0.1-0.4 0.1-0.2 0-0.7-0.2t-0.7-0.2q-0.4 0-0.8 0.3t-0.4 0.7q0 0.5 0.4 0.8t1 0.5 0.9 0.4 0.5 0.5q0 0.3-0.2 0.6-1.4 3.1-4.4 3.7-0.5 0.1-0.5 0.6 0 1.1 3.1 1.6 0 0.1 0.1 0.5t0.3 0.7 0.5 0.2q0.3 0 0.8-0.1t0.9-0.1q0.8 0 1.5 0.4t1.2 0.7 1.3 0.7 1.7 0.3q1 0 1.8-0.3t1.3-0.7 1.2-0.7 1.5-0.4q0.3 0 0.8 0.1t0.9 0.1q0.4 0 0.5-0.2t0.3-0.7 0.1-0.5q3.1-0.5 3.1-1.6z m5.7-16.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
        )
    );
};

exports.default = FaSnapchatSquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/snapchat-square.js
// module id = 535
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464